import { Component, HostListener, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { AppPages } from '@constants/app-pages';
import { Vehicle } from '@domain/dto/vehicle/vehicle-get.dto';
import { environment } from '@environment/environment';
import { ReservaService } from '@infra/reserva/reserva.service';
import { VehicleController } from '@presentation/controllers/vehicles/vehicle.controller';
import { BottomSheetComponent } from '@presentation/view/shared/components/bottom-sheet/bottom-sheet.component';
import * as moment from 'moment';
import { AnimationOptions } from 'ngx-lottie';
import { finalize } from 'rxjs';
import { DateUtil } from 'src/app/shared/utils/date.util';

@Component({
  selector: 'app-vehicles',
  templateUrl: './vehicles.component.html',
  styleUrls: ['./vehicles.component.scss'],
})
export class VehiclesComponent implements OnInit {
  vehicles: any[] = [];
  isLoading: boolean = false;
  summaryInvisible: boolean = true;
  vehiclesAvailable: boolean = false;
  isMobile: boolean = false;
  showVehicleAdditionalsArray: any[] = [];
  diasReserva: number = 1;
  customCurrencyDefault: string;

  selectedOption: AnimationOptions = {
    path: './assets/json/selected.json',
    loop: false,
  };
  carLoading: AnimationOptions = {
    path: './assets/json/car-loading.json',
    loop: true,
  };
  noVehiclesAvailable: AnimationOptions = {
    path: './assets/json/not-found.json',
    loop: false,
  };

  currentLanguage: string;

  constructor(
    private controller: VehicleController,
    public reservaService: ReservaService,
    private _bottomSheet: MatBottomSheet,
    private router: Router
  ) {

    this.currentLanguage = localStorage.getItem('language')
    this.customCurrencyDefault = sessionStorage.getItem('customCurrencyDefault')
}

  async ngOnInit() {
    this.onResize();
    if (history.state.useDataFromStorage) {
      this.vehicles = this.reservaService.vehiclesData;
      this.vehicles.filter(
        (i: any) => i?.CodigoGrupo === this.reservaService.reservasData.CodigoGrupo
      )[0].active = true;
      this.vehicles.filter((i: any) =>
        i?.VeiculosDisponiveis ? (this.vehiclesAvailable = true) : null
      );
      this.summaryInvisible = false;
    } else await this.getVehicles();
    this.scrollTop();
    this.diffDays();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?: any) {
    if (window.innerWidth <= 960) this.isMobile = true;
    else this.isMobile = false;
  }

  diffDays() {
    if (
      this.reservaService?.homeData?.firstDateSelected &&
      this.reservaService?.homeData?.secondDateSelected
    ) {

      if (environment.defaultLanguage === 'en-US') {
        var date1 = new Date(this.reservaService?.homeData?.firstDateSelected);
        var date2 = new Date(this.reservaService?.homeData?.secondDateSelected);
      } else {
        var date1 = new Date(
          DateUtil.changeDDMMtoMMDD(this.reservaService?.homeData?.firstDateSelected)
        );
        var date2 = new Date(
          DateUtil.changeDDMMtoMMDD(this.reservaService?.homeData?.secondDateSelected)
        );
      }
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      this.diasReserva = diffDays;
    }
  }


  async getVehicles() {

    let dataInicioFormatada = decodeURIComponent(this.reservaService.homeData.firstDateSelected)
    let dataTerminoFormatada = decodeURIComponent(this.reservaService.homeData.secondDateSelected)
    let horaInicioFormatada = decodeURIComponent(this.reservaService.homeData.firstHourSelected)
    let horaTerminoFormatada = decodeURIComponent(this.reservaService.homeData.secondHourSelected)

    if (environment.defaultLanguage === 'en-US') {
      horaInicioFormatada = moment(horaInicioFormatada, 'h:mm A').format('HH:mm')
      horaTerminoFormatada = moment(horaTerminoFormatada, 'h:mm A').format('HH:mm')
      dataInicioFormatada = moment(dataInicioFormatada, 'MM/DD/YYYY').format('MM-DD-YYYY')
      dataTerminoFormatada = moment(dataTerminoFormatada, 'MM/DD/YYYY').format('MM-DD-YYYY')
    } else {
      dataInicioFormatada = moment(dataInicioFormatada, 'DD/MM/YYYY').format('MM-DD-YYYY')
      dataTerminoFormatada = moment(dataTerminoFormatada, 'DD/MM/YYYY').format('MM-DD-YYYY')
      horaInicioFormatada = moment(horaInicioFormatada, 'h:mm').format('HH:mm')
      horaTerminoFormatada = moment(horaTerminoFormatada, 'h:mm').format('HH:mm')
    }

    let params = {
      codigoEmpresa: this.reservaService.homeData.firstSelectedCity.CodigoEmpresa,
      codigoUnidade: this.reservaService.homeData.firstSelectedCity.CodigoUnidade,
      dataInicio: dataInicioFormatada,
      dataTermino: dataTerminoFormatada,
      horaInicio: horaInicioFormatada,
      horaTermino: horaTerminoFormatada,
      codigoEmpresaDevolucao: this.reservaService.homeData.secondSelectedCity.CodigoEmpresa,
      codigoUnidadeDevolucao: this.reservaService.homeData.secondSelectedCity.CodigoUnidade,
      codigoMunicipioRetirada: this.reservaService.homeData.firstSelectedCity.CodigoMunicipio,
      codigoMunicipioDevolucao: this.reservaService.homeData.secondSelectedCity.CodigoMunicipio,
      Router: sessionStorage.getItem('Router')
    };

    this.isLoading = true;
    this.controller
      .get(params)
      .pipe(
        finalize(() => {
          this.isLoading = false;
          if (this.reservaService.reservasData) {
            this.vehicles.filter(
              (i: any) => i?.CodigoGrupo === this.reservaService.reservasData.CodigoGrupo
            )[0].active = true;
            this.summaryInvisible = false;
          }
        })
      )
      .subscribe((vehicle: any) => {
        this.vehicles.push(vehicle as Vehicle);
        this.reservaService.vehiclesData = this.vehicles;
        this.vehicles.filter((i: any) =>
          i?.VeiculosDisponiveis ? (this.vehiclesAvailable = true) : null
        );
      });
  }

  onSelectCard(vehicle: any) {
    if (vehicle) {
      this.vehicles.forEach((item: any, index: number) => {
        this.vehicles[index].active = false;
      });
      this.vehicles.filter((i: any) => i?.CodigoGrupo === vehicle.CodigoGrupo)[0].active = true;
      this.reservaService.reservasData = {
        CodigoEmpresa: this.reservaService?.reservasData?.CodigoEmpresa, // Campos inalterados
        CodigoUnidade: this.reservaService?.reservasData?.CodigoUnidade, // Campos inalterados
        CodigoCliente: this.reservaService?.reservasData?.CodigoCliente, // Campos inalterados
        CodigoGrupo: vehicle?.CodigoGrupo,
        CodigoEmpresaDevolucao: this.reservaService?.reservasData?.CodigoEmpresaDevolucao, // Campos inalterados
        CodigoUnidadeDevolucao: this.reservaService?.reservasData?.CodigoUnidadeDevolucao, // Campos inalterados
        CodigoProtecao: this.reservaService?.reservasData?.CodigoProtecao, // Campos inalterados
        CodigoTarifa: this.reservaService?.reservasData?.CodigoTarifa, // Campos inalterados
        DataInicio: this.reservaService?.reservasData?.DataInicio, // Campos inalterados
        DataTermino: this.reservaService?.reservasData?.DataTermino, // Campos inalterados
        HoraInicio: this.reservaService?.reservasData?.HoraInicio, // Campos inalterados
        HoraTermino: this.reservaService?.reservasData?.HoraTermino, // Campos inalterados
        CodigoMunicipioRetirada: this.reservaService?.reservasData?.CodigoMunicipioRetirada, // Campos inalterados
        CodigoMunicipioDevolucao: this.reservaService?.reservasData?.CodigoMunicipioDevolucao, // Campos inalterados
        Origem: this.reservaService?.reservasData?.Origem, // Campos inalterados
        ValorLocacaoJovem: this.reservaService?.reservasData?.ValorLocacaoJovem, // Campos inalterados
        PercDescontoTempo: this.reservaService?.reservasData?.PercDescontoTempo, // Campos inalterados
        ValorHoraExtra: this.reservaService?.reservasData?.ValorHoraExtra ?? 0,
        Adicionais: this.reservaService?.reservasData?.Adicionais, // Campos inalterados
        CobrarDiariaAMaisHoraExtra: this.reservaService?.reservasData?.CobrarDiariaAMaisHoraExtra, // Campos inalterados
      };
      this.reservaService.vehicleData = vehicle;
      this.summaryInvisible = false;
      this.reservaService.taxaAdministrativa = vehicle?.TaxaAdministrativa || 0;
    }
  }

  changeVehicleAdditionalsVisibility(index: any) {
    if (this.showVehicleAdditionalsArray.indexOf(index) == -1)
      this.showVehicleAdditionalsArray.push(index);
    else
      this.showVehicleAdditionalsArray = this.showVehicleAdditionalsArray.filter(
        (e) => e !== index
      );
  }

  verifyElementInAdditionalsArray(index: number) {
    return this.showVehicleAdditionalsArray.indexOf(index) == -1;
  }

  openBottomSheet(): void {
    this._bottomSheet.open(BottomSheetComponent, {
      panelClass: 'mat-bottom-sheet-container',
      data: {
        showSecondDiv: false,
        totalPrice: 0,
        totalPriceDiscount: 0,
        additionalsPrice: 0,
      },
    });
  }

  async nextPage() {
    this.reservaService.taxaAdministrativa =
      JSON.parse(localStorage.getItem('vehicleData') || '{}').TaxaAdministrativa || 0;
    await this.reservaService.clearProtectionsTariffAndAdditionalsData();
    this.router.navigateByUrl(AppPages.ADDITIONALS);
    this.reservaService.maxStepAllowed = '2';
  }

  async backPage() {
    this.router.navigateByUrl(AppPages.HOME, { state: { useDataFromStorage: true } });
  }

  scrollTop() {
    let elmntToView = document.getElementById('top')!;
    elmntToView.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
  }

  get isStepValid(): boolean {
    return !this.isLoading 
  }
}
